export default __webpack_public_path__ + "static/media/GroundMac_Logo.942732c1.png";